import { Button } from '@consigli/facade';
import { FaClock, FaTimesCircle } from 'react-icons/fa';

import type { IconType } from 'react-icons';

type AlertVariant = 'error' | 'warning';

const variantStyles: Record<
  AlertVariant,
  { container: string; iconClass: string; title: string; message: string; Icon: IconType }
> = {
  error: {
    container: 'bg-red-50 border-red-200',
    iconClass: 'text-red-500',
    title: 'text-red-800',
    message: 'text-red-700',
    Icon: FaTimesCircle,
  },
  warning: {
    container: 'bg-yellow-50 border-yellow-200',
    iconClass: 'text-yellow-500',
    title: 'text-yellow-800',
    message: 'text-yellow-700',
    Icon: FaClock,
  },
};

interface ErrorAlertProps {
  title: string;
  message: string;
  variant?: AlertVariant;
  onRetry?: () => void;
  retryLabel?: string;
}

export const ErrorAlert = ({
  title,
  message,
  variant = 'error',
  onRetry,
  retryLabel = 'Try Again',
}: ErrorAlertProps) => {
  const {
    container,
    iconClass,
    title: titleClass,
    message: messageClass,
    Icon,
  } = variantStyles[variant];
  return (
    <div className={`border rounded-lg p-4 ${container}`}>
      <div className="flex items-start space-x-3">
        <Icon className={`mt-0.5 ${iconClass}`} />
        <div>
          <h3 className={`font-medium ${titleClass}`}>{title}</h3>
          <p className={`text-sm mt-1 ${messageClass}`}>{message}</p>
          {onRetry && (
            <Button error rounded onClick={onRetry} className="mt-2 !text-sm !px-3 !py-1">
              {retryLabel}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
